import {
  DELETE_ALL_VALUES_WEB_MANAGEMENT,
  SET_VALUE_WEB_MANAGEMENT,
} from "constants/types";

const initialState = {
  about_us: "",
  about_us_images: [],
  our_vision: "",
  our_vision_images: [],
  publisher_images: [],
  delete_img_id: [],
};

export default function(state = initialState, action) {
  switch (action.type) {
    case SET_VALUE_WEB_MANAGEMENT:
      return {
        ...state,
        ...action.payload,
      };
    case DELETE_ALL_VALUES_WEB_MANAGEMENT:
      return initialState;
    default:
      return state;
  }
}
